import * as React from "react";

import { cn } from "@/shared/lib/utils";

// shadcn/ui placeholder interface; kept for future extension parity
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          // 配色走皮肤 token,3 套皮肤都可读;cyber 等宽 + 霓虹边由 skin-cyber.css `.cyber-textarea` 覆写
          "cyber-textarea flex min-h-[80px] w-full rounded-md px-3 py-2 text-sm",
          "border border-input bg-background text-foreground",
          "transition-all duration-200",
          "placeholder:text-muted-foreground",
          "hover:border-ring/60",
          "focus-visible:outline-none focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/40",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
